(() => {
  const KEY = 'CapirusBundlePacksInline';

  function isAvailable(val) {
    return val === true || val === 'true' || val === '1' || val === 1;
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Cart add failed');
    }
    return res.json();
  }

  function initOne(root) {
    if (!root || root.dataset.bpiInit === '1') return;
    root.dataset.bpiInit = '1';
    root.classList.add('is-js');

    const form = root.querySelector('form.bundle-form');
    const msg = root.querySelector('.bundle-msg');
    const hiddenId = form?.querySelector('input[name="id"]');
    const buyNowBtn = root.querySelector('.bundle-buy-now');
    const radios = Array.from(root.querySelectorAll('input.logic-radio'));
    const summary = root.querySelector('[data-bundle-summary]');
    const summaryPrice = root.querySelector('[data-summary-price]');
    const summaryCompare = root.querySelector('[data-summary-compare]');
    const summaryDiscount = root.querySelector('[data-summary-discount]');
    const summaryPerDay = root.querySelector('[data-summary-per-day]');

    if (!form || !hiddenId || !buyNowBtn || radios.length === 0) return;

    const texts = {
      added: root.dataset.addedText || 'Añadido ✔',
      error: root.dataset.errorText || 'No se pudo añadir. Inténtalo de nuevo.',
      oos: root.dataset.oosText || 'Sin stock en la opción seleccionada'
    };
    const checkoutUrl = root.dataset.checkoutUrl || '/checkout';

    function getChecked() {
      let checked = radios.find(r => r.checked);
      if (!checked) {
        radios[0].checked = true;
        checked = radios[0];
      }
      return checked;
    }

    function syncHidden() {
      const checked = getChecked();
      hiddenId.value = checked.value;
    }

    function syncSummary() {
      const checked = getChecked();
      if (!summary || !checked) return;

      if (summaryPrice) summaryPrice.textContent = checked.dataset.priceText || '';
      if (summaryCompare) summaryCompare.textContent = checked.dataset.compareText || '';
      if (summaryDiscount) summaryDiscount.textContent = checked.dataset.discountText || '';
      if (summaryPerDay) summaryPerDay.textContent = checked.dataset.perDayText || '';
    }

    // Initial sync
    syncHidden();
    syncSummary();

    // Keep hidden input synced (por si el usuario usa fallback sin JS)
    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.classList && t.classList.contains('logic-radio')) {
        syncHidden();
        syncSummary();
      }
    });

    buyNowBtn.addEventListener('click', async () => {
      const checked = getChecked();
      syncHidden();

      // UI state
      buyNowBtn.disabled = true;
      if (msg) { msg.hidden = true; msg.textContent = ''; }

      // Stock
      if (!isAvailable(checked.dataset.available)) {
        if (msg) { msg.textContent = texts.oos; msg.hidden = false; }
        buyNowBtn.disabled = false;
        return;
      }

      const mainId = Number(checked.value);
      const giftId = checked.dataset.giftId ? Number(checked.dataset.giftId) : null;
      const giftQty = checked.dataset.giftQty ? parseInt(checked.dataset.giftQty, 10) : 0;

      const items = [{ id: mainId, quantity: 1 }];

      if (giftId && giftQty > 0) {
        items.push({
          id: giftId,
          quantity: giftQty,
          properties: { _gift: 'Capirus', _parent: String(mainId) }
        });
      }

      try {
        await addItems(items);
        window.location.assign(checkoutUrl);
      } catch (err) {
        // Fallback: intenta añadir solo el pack (por si el regalo falla)
        try {
          await addItems([{ id: mainId, quantity: 1 }]);
          window.location.assign(checkoutUrl);
          return;
        } catch (_) {}

        if (msg) {
          msg.textContent = texts.error;
          msg.hidden = false;
        }
        buyNowBtn.disabled = false;
      }
    });
  }

  function initAll(ctx = document) {
    const roots = ctx.querySelectorAll('[data-bundle-inline]');
    roots.forEach(initOne);
  }

  // Expose (por si quieres debug)
  window[KEY] = window[KEY] || { initAll };

  // Init on first load
  document.addEventListener('DOMContentLoaded', () => initAll(document));

  // Shopify Theme Editor: cuando recarga secciones, re-inicializa
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initAll(e.target));
})();
